import React from 'react'
import styles from './loading-screen.styles'
import injectSheet from 'react-jss'
import Bone from 'pobble-components/dist/bone'

const Cell = ({ children, style }) => (
  <td
    style={{
      textAlign: 'center',
      padding: '20px 10px',
      borderBottom: '1px solid #ececec',
      ...style
    }}>
    {children}
  </td>
)
const GroupRow = ({ groupWidth }) => (
  <tr>
    <Cell>
      <Bone style={{ width: '20px', height: '20px', borderRadius: '4px' }} />
    </Cell>
    <Cell style={{ textAlign: 'left' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Bone
          style={{
            flexShrink: '0',
            width: '32px',
            height: '32px',
            borderRadius: '32px',
            marginRight: '10px'
          }}
        />
        <Bone style={{ width: groupWidth, height: '14px' }} />
      </div>
    </Cell>
    <Cell>
      <Bone style={{ width: '18px', height: '18px' }} />
    </Cell>
    <Cell>
      <Bone style={{ width: '18px', height: '18px' }} />
    </Cell>
    <Cell style={{ textAlign: 'right' }}>
      <Bone style={{ width: '40px', height: '40px', borderRadius: '5px' }} />
    </Cell>
  </tr>
)

const LoadingScreen = ({ classes }) => (
  <div className={classes.container}>
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Bone style={{ width: '110px', height: '40px', borderRadius: '4px' }} />
    </div>
    <table>
      <tbody>
        <tr>
          <Cell>
            <Bone style={{ width: '30px' }} />
          </Cell>
          <Cell>
            <Bone style={{ width: '60px' }} />
          </Cell>
          <Cell>
            <Bone style={{ width: '66px' }} />
          </Cell>
          <Cell>
            <Bone style={{ width: '78px' }} />
          </Cell>
          <Cell />
        </tr>
        <GroupRow groupWidth="120px" />
        <GroupRow groupWidth="130px" />
        <GroupRow groupWidth="70px" />
        <GroupRow groupWidth="90px" />
        <GroupRow groupWidth="100px" />
        <GroupRow groupWidth="80px" />
      </tbody>
    </table>
  </div>
)

export default injectSheet(styles)(LoadingScreen)
